import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import {
  ROLE_ADMIN,
  ROLE_FRONT_DESK,
  ROLE_OWNER,
  normalizedRoleId,
  roleIdSetForUser,
} from '../context/AuthContext';

/**
 * Protects routes that require authentication.
 * Optionally restrict by role (e.g. only Owner can access dashboard).
 * requireFrontDeskStaff: Admin or Front Desk (matches API /front-desk/*).
 */
export function ProtectedRoute({
  children,
  requireOwner = false,
  requireFrontDeskStaff = false,
  requireAccountProfileAbility = false,
}) {
  const { user, loading, canAccessProfilePage } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const rid = normalizedRoleId(user);
  if (requireOwner && rid !== ROLE_OWNER && rid !== ROLE_ADMIN && user.role !== 'Owner' && user.role !== 'Admin') {
    return <Navigate to="/" replace />;
  }

  if (requireFrontDeskStaff) {
    const ids = roleIdSetForUser(user);
    const ok =
      ids.has(ROLE_ADMIN) ||
      ids.has(ROLE_FRONT_DESK) ||
      ids.has(ROLE_OWNER) ||
      user.role === 'Admin' ||
      user.role === 'Front Desk' ||
      user.role === 'Owner';
    if (!ok) {
      return <Navigate to="/" replace />;
    }
  }

  if (requireAccountProfileAbility && !canAccessProfilePage) {
    return <Navigate to="/front-desk" replace />;
  }

  return children;
}
